import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
const zh = {
    stock: {
        //'systemName': '维泰信息平台',
        'systemName': '意历维信息平台',
        'mainPage': '首页',
        'saleCode': '产品码',
        'tabtitle':'产品码查询',
        'tabtitle_pic':'画册查询',
        'tabtitle_sample':'样本查询',
        'tabtitle_express_delivery': '运单查询',
        'saleCodeTip': '请输入产品码',
        'pictureCoding':'请选择画册编码',
        'sampleCoding':'请选择样本编码',
        'choosestatus':'请选择状态',
        'deliveryCodeTip': '请输入发货单号或销售订单号',
        'statetypeone':'全部',
        'statetypetwo':'补货中',
        'exportdata':'导出',
        'search': '查询',
        'maxLengthofABlock': '可售库存',
        'brand':'品牌',
        'clearance':'清货',
        'clearanceContent':'清货',
        'photo':'图样',
        'latestReplenishmentDate': '最新补货日期',
        'operation': '操作',
        'details': '详情',
        'basicInformation': '基本信息',
        'remarks': '备注',
        'chinese': '中文',
        'english': 'English',
        'endOfSale': '停售',
        'yarn': '面料',
        'component': '成分',
        'weight': '克重',
        'supplying': '补货中',
        '40over': '40+',
        '50over': '50+',
        '60over': '60+',
        '70over': '70+',
        'chooselanguage': 'Language',
        'doNo': '发货单号',
        'expressNo': '运单号',
        'refSoNo': '销售订单号',
        'remarks': '备注',
        'deliveryRemarks': '出库中',
        'deliverySearchTip1': '出库中，请稍后！',
        'deliverySearchTip2': '暂时不支持该发运方式的运单追踪！',

        'qrScan': '扫描二维码',
        'qrScan2': 'QR SCAN',
        'barScan': '扫描条形码',
        'barScan2': 'BAR SCAN',
        'productNoTip': '请输入产品码',

        'ocr': '',
        'ocrText': '输入品号，查询库存.',

        'brand': '品牌',
        'inventory': '库存',
        'code': '品号',
        'replenishment': '补货日期',
        'yarn': '纱支',
        'component': '成分',
        'weight': '克重',
    },
    ...zhLocale

}

export default zh;
